export const DEBUG_TRACKING = false; // explicit console logging
export const DISABLED_TRACKING_DOMAINS = ["di.local", "localhost"]; // disable tracking for these domains
